import { GET_USER_DATA, RESET_USER_DATA } from "../actions/userActions"

const initState = {
  user: [],
}

const userReducer = (state = initState, action) => {
  if (action.type === GET_USER_DATA) {
    return {
      ...state,
      user: action.payload,
    }
  } else if (action.type === RESET_USER_DATA) {
    return {
      ...state,
      user: [],
    }
  }

  return state
}

export default userReducer
